/** React */
import { useState } from "react";

/** MUI */
import {
    MenuItem,
    Typography,
} from "@mui/material";

/** Components */
import BaseSelect from "../ui/BaseSelect";
import classes from "./pricing.module.css";
import plansInfo from "../../utils/plans";

const PlanCard = (props) => {
    const { planType } = props;

    /** Component states */
    const [currentLevel, setCurrentLevel] = useState(
        plansInfo[planType].planTitle === "Small" ? 3 : plansInfo[planType].planTitle === "Medium" ? 8 : 13
    );
    const [priceMonthly, setPriceMonthly] = useState(
        plansInfo[planType].planTitle === "Small" ? 29 : plansInfo[planType].planTitle === "Medium" ? 199 : 749
    );

    /** Component functions */
    const handleChange = (event, type) => {
        const currentLevel = plansInfo[type].levels.find((item) => item.id === event.target.value);
        setCurrentLevel(currentLevel.id);
        setPriceMonthly(currentLevel.price);
    };

    return (
        <>
            <Typography variant="h2" textAlign="center" className={classes.paddingBSmall}>
                {planType === 1 ? "Small" : planType === 2 ? "Medium" : "Enterprise"}
            </Typography>
            <Typography textAlign="center" className={classes.paddingBSmall2}>
                <Typography variant="body4">
                    {planType === 1
                        ? "Best for growing businesses"
                        : planType === 2
                        ? "Best for established businesses"
                        : "Best for scaling businesses"}
                </Typography>
                
            </Typography>
            <Typography variant="body1" fontWeight={700} textAlign="center" gutterBottom className={classes.paddingB}>
                US${" "}
                {!(plansInfo[planType].levels.find((item) => item.id === currentLevel)?.custom === true)
                    ? `${priceMonthly}/month`
                    : "Custom"}
            </Typography>
            <BaseSelect
                id="pricing"
                label="Pages to convert"
                value={currentLevel}
                onChange={(e) => handleChange(e, planType)}
                // size="small"
            >
                {plansInfo[planType].levels.map((item, index) => (
                    <MenuItem value={item.id} key={index} sx={{ whiteSpace: "nowrap" }}>
                        {!(item?.custom === true) ? `${item.pages} pages/month` : "Custom"}
                    </MenuItem>
                ))}
            </BaseSelect>
            <Typography variant="body3" fontWeight={700} className={classes.showMobile}>
                Processing pricing
            </Typography>
            <Typography className={classes.paddingTLarge2}>
                <Typography fontWeight={600} component="span" className={classes.showMobileT} variant="body3">
                    Checks:
                </Typography>{" "}
                <Typography variant="body3">
                    0.5 pages each
                </Typography>
            </Typography>
            <Typography className={classes.text}>
                <Typography fontWeight={600} component="span" className={classes.showMobileT} variant="body3">
                    Invoices/statements:
                </Typography>{" "}
                <Typography variant="body3">
                    Pages per document
                </Typography>
            </Typography>
            <Typography className={classes.text2}>
                <Typography fontWeight={600} component="span" className={classes.showMobileT} variant="body3">
                    Transactions:
                </Typography>{" "}
                <Typography variant="body3">
                    0.1 pages each
                </Typography>
            </Typography>
            <Typography fontWeight={700} className={classes.showMobile2} variant="body3">
                Customer support
            </Typography>
            <Typography className={classes.paddingTLarge}>
                <Typography variant="body3">
                    {planType === 3 ? "Personalized" : "Standard"}{" "}
                </Typography>
                <Typography component="span" className={classes.showMobileT} variant="body3">
                    onboarding
                </Typography>
            </Typography>
            <Typography className={classes.text}>
                <Typography variant="body3">
                    {planType === 1 ? "In-app" : planType === 2 ? "In-app | Email" : "In-app | Email | Phone"}{" "}
                </Typography>
                <Typography component="span" className={classes.showMobileT} variant="body3">
                    support
                </Typography>
            </Typography>
            <Typography className={classes.text}>
                <Typography variant="body3">
                    {planType === 3 ? "Account Managers" : "Customer Specialists"}{" "}
                </Typography>
                <Typography component="span"  className={classes.showMobileT} variant="body3">
                    attention
                </Typography>
            </Typography>
        </>
    );
};

export default PlanCard;